import SectionHeading from './SectionHeading';
import { endingParagraphs, endingReadings, endingTakeaway } from '@/mocks/ending';

export default function EndingSection() {
  return (
    <section id="ending" className="scroll-mt-24 bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Ending"
          title="结局深度解析"
          desc="结局不是终点，而是把问题交还给你。这一节从结构、动机和留白三个角度拆开看。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Moody%20cinematic%20still%20life%20of%20a%20long%20wooden%20dining%20table%20with%20cold%20leftover%20dishes%2C%20faded%20wine%20glasses%20and%20dim%20amber%20light%20in%20an%20empty%20room%2C%20melancholic%20quiet%20atmosphere%2C%20deep%20wine%20red%20and%20warm%20tones%2C%20no%20people%2C%20fine%20art%20photography&width=900&height=1100&seq=ending-adultery-2026&orientation=portrait"
                alt="空房间里冷掉的餐桌与酒杯，呼应结局的冷收尾氛围"
                className="h-64 w-full object-top object-cover md:h-[420px]"
              />
            </div>
            <div className="mt-4 rounded-lg border border-primary-200 bg-primary-50 p-4 md:p-5">
              <p className="font-label text-xs uppercase tracking-wider text-primary-700">{endingTakeaway.title}</p>
              <p className="mt-2 text-xs leading-relaxed text-primary-950 md:text-sm">{endingTakeaway.text}</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="space-y-5">
              {endingParagraphs.map((para, index) => (
                <p key={index} className="text-sm leading-loose text-foreground-700 md:text-base">
                  {para}
                </p>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {endingReadings.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}